type AbortExit = () => void;
type ConfirmExit = () => Promise<boolean>;

interface UnsavedChangesGuard {
	abortExit: AbortExit;
	confirmExit: ConfirmExit;
}

const guards = new Map<string, UnsavedChangesGuard>();

export const registerUnsavedChanges = (key: string, guard: UnsavedChangesGuard): void => {
	guards.set(key, guard);
};

export const unregisterUnsavedChanges = (key: string): void => {
	guards.delete(key);
};

export const hasUnsavedChanges = (): boolean => guards.size > 0;

export const confirmUnsavedChangesExit = async (): Promise<boolean> => {
	for (const { confirmExit } of [...guards.values()]) {
		if (!(await confirmExit())) return false;
	}
	return true;
};

// Confirming an exit is not committing to it: a caller whose proceed() bails still owns the
// still-mounted form, and has to hand the guard back what confirmExit spent on its behalf.
export const abortUnsavedChangesExit = (): void => {
	for (const { abortExit } of [...guards.values()]) abortExit();
};

const runGuardedExit = (proceed: () => void): void => {
	if (!hasUnsavedChanges()) {
		proceed();
		return;
	}
	void confirmUnsavedChangesExit().then((confirmed) => {
		if (confirmed) proceed();
	});
};

export default runGuardedExit;
